export const meta = { id: 'O34.1', slug: 'integracao-formacao-jornada', title: 'Como Formação e Jornada trabalham juntas', description: 'Entenda como uma Formação pode integrar o percurso da Jornada, o progresso e a próxima ação do participante.', profile: 'owner', category: 'formacoes', type: 'flow', status: 'published', order: 645, keywords: ['formação','jornada','integração','próxima ação','progresso'], previous: 'O34', next: 'O35', related: ['O20','A05','A06'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como Formação e Jornada trabalham juntas

A Jornada organiza o percurso. A Formação pode fazer parte desse percurso como um programa estruturado de desenvolvimento.

Quando integradas, a execução da Formação pode influenciar a posição do participante na Jornada, seu progresso e a próxima ação apresentada pelo Personagrama.

## O que revisar ao integrar

- se a Formação está posicionada no ponto correto da Jornada;
- se o participante consegue entender qual experiência vem antes e depois;
- se o progresso da Formação é refletido de forma coerente no percurso;
- se bloqueios e pré-requisitos não criam um caminho contraditório;
- se a próxima ação direciona o participante para algo realmente disponível.

<Callout type="concept">Jornada organiza o caminho; Formação estrutura um programa dentro ou ao lado desse caminho.</Callout>
